import client from "../libs/HttpClient";

class TutorialServices {
  static getTutorialList(request) {
    return client.get(`tutorial`, request);
  }
}

export { TutorialServices };
